import { stringify } from 'qs'
import { HttpClient } from '../../httpClient'
import { OpalApiRequestParams, OpalApiResponseDocument } from '../../schema'

type ReadStoriesParams = OpalApiRequestParams<'ReadStoriesV2'>
type ReadStoriesQueryParams = ReadStoriesParams['query']

type StoriesReadParams = {
  filter?: ReadStoriesQueryParams['filter']
  page?: ReadStoriesQueryParams['page']
  sort?: Array<ReadStoriesQueryParams['sort']>
}

export const readStories = async (
  params: StoriesReadParams
): Promise<OpalApiResponseDocument<'ReadStoriesV2', 200>> => {
  const url = new URL('/stories/v2', window.location.origin)

  url.search = stringify(
    { ...params, sort: params.sort?.join(',') },
    { arrayFormat: 'brackets' }
  )

  return HttpClient()
    .get<OpalApiResponseDocument<'ReadStoriesV2', 200>>(url.toString())
    .then((res) => res.data)
}
